module.exports = __webpack_public_path__ + "static/media/Catalog.674a78a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductLandingPage/images/Catalog.svg
// module id = 1019
// module chunks = 0